import { inject } from '@angular/core';
import { Route } from '@angular/router';

import { ProfileService, adminGuard, features, subscriptionGuard } from '@tfs/auth';

import { isNonProdEnvironment } from '../environment.config';

export const appRoutes: Route[] = [
  {
    path: 'library',
    data: { features: [features.ToolManagementBasic] },
    canActivate: [subscriptionGuard],
    children: [
      {
        path: 'tool-import',
        loadChildren: () => import('@tfs/tool-import-shell').then(m => m.shellToolImportRoutes),
      },

      {
        path: 'cam-import',
        canMatch: [() => inject(ProfileService).camImportEnabled()],
        loadChildren: () => import('@tfs/tool-import-shell').then(m => m.shellCamImportRoutes),
      },

      {
        path: 'work-order-management',
        canMatch: [() => inject(ProfileService).workOrderManagementEnabled()],
        loadChildren: () =>
          import('@tfs/work-order-management-shell').then(m => m.workOrderShellRoutes),
      },
      {
        path: '',
        loadChildren: () => import('@tfs/tool-library-shell').then(m => m.toolLibraryShellRoutes),
      },
    ],
  },
  {
    path: 'account',
    canActivate: [subscriptionGuard],
    loadChildren: () => import('@tfs/account-shell').then(m => m.shellAccountRoutes),
  },
  {
    path: 'store',
    loadComponent: () => import('@tfs/account-shell').then(m => m.StoreComponent),
    canMatch: [adminGuard],
  },
  {
    path: 'error',
    loadComponent: () => import('@tfs/errors').then(m => m.ErrorPageComponent),
  },
  {
    path: 'dev',
    canMatch: [isNonProdEnvironment],
    loadComponent: () =>
      import('./developer-page/developer-page.component').then(m => m.DeveloperPageComponent),
  },
  {
    path: 'dev/viewer-tester',
    canMatch: [isNonProdEnvironment],
    loadComponent: () =>
      import('./viewer-tester/viewer-tester.component').then(m => m.ViewerTesterComponent),
  },
  { path: '**', redirectTo: 'library' },
];
